import { Button, TextField } from "@aws-amplify/ui-react";
import { useForm } from "react-hook-form";
import AuthFormShell from "./AuthFormShell";

interface ConfirmTotpFormValues {
  code: string;
}

interface ConfirmTotpFormProps {
  onSubmit: (code: string) => void;
  onBack: () => void;
  onDismissError?: () => void;
  error?: string | null;
  isLoading?: boolean;
}

const ConfirmTotpForm = ({ onSubmit, onBack, onDismissError, error, isLoading }: ConfirmTotpFormProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ConfirmTotpFormValues>({ mode: "onSubmit" });

  return (
    <AuthFormShell
      heading="Two-factor authentication"
      onSubmit={handleSubmit((data) => onSubmit(data.code.trim()))}
      error={error}
      onDismissError={onDismissError}
      fields={
        <TextField
          label="Please enter the 6-digit code from your authenticator app to verify your identity."
          placeholder="XXX-XXX"
          autoComplete="one-time-code"
          inputMode="numeric"
          {...register("code", { required: "Code is required" })}
          hasError={!!errors.code}
          errorMessage={errors.code?.message}
        />
      }
      actions={
        <>
          <Button type="submit" variation="primary" isFullWidth isLoading={isLoading}>
            Confirm
          </Button>
          <Button type="button" variation="link" onClick={onBack} className="amplify-button--link">
            Back to Sign In
          </Button>
        </>
      }
    />
  );
};

export default ConfirmTotpForm;
